import React, { useState, useEffect } from "react";
import Section from "../../components/Section";
import axios from "axios";

import { ailogo } from "../../assets";

const AiHero = () => {
  const textList = [
    "Sound Human",
    "Engage Customers",
    "Provide 24/7 Help",
    "Qualify Leads",
    "Book Sessions",
    "Drive Sales",
    "Optimize Costs",
  ];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "AI Calling Agent", // Preselect "AI Calling Agent"
    message: "",
  });

  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // New state for loading spinner

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const token = await window.grecaptcha.execute(
        "6LdP2KcqAAAAALIVF5tv-48L6P85fgm_y8CbmB12",
        {
          action: "submit",
        },
      );
      const response = await axios.post(
        "/contact-form/submit_form.php", // Update with your PHP script URL
        { ...formData, token },
      );
      setStatus(response.data.message);

      // Reset the form after 4 seconds
      setTimeout(() => {
        setFormData({
          name: "",
          email: "",
          phone: "",
          service: "AI Calling Agent", // Keep service as AI Calling Agent
          message: "",
        });
        setStatus("");
        // Close the overlay after form submission
      }, 4000);
    } catch (error) {
      console.error(error);
      setStatus("Failed to submit the form. Please try again later.");
      setTimeout(() => {
        setStatus("");
      }, 4000);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(true); // Start fade-out animation
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % textList.length);
        setFade(false); // Start fade-in animation
      }, 300); // Sync with fadeOut duration
    }, 3000); // Change text every 3 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [textList.length]);

  return (
    <Section>
      <section className="n container mx-auto mt-4 px-4 md:px-8 lg:px-16">
        {/* Header Section */}
        <div className="mb-12 text-center">
          <h1 className="h1">Automate Calls with AI That</h1>

          <h2
            className={`h7 h3 bg-gradient-to-r from-purple-500 to-purple-600 bg-clip-text font-semibold text-transparent transition-opacity duration-300 sm:h1 ${
              fade ? "opacity-0" : "opacity-100"
            }`}
          >
            {textList[currentIndex]}
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-base text-gray-300 sm:text-lg">
            Create artificial intelligence-powered, human-like AI voice agents
            ready to handle your phone calls 24/7, in 60 seconds or less.
          </p>
        </div>

        {/* Video and Form Section */}
        <div className="flex flex-col items-stretch gap-8 min-[900px]:flex-row">
          {/* Video Section */}
          <div className="relative h-[500px] w-full overflow-hidden rounded-3xl shadow-2xl min-[900px]:w-[60%]">
            <video
              src="/ai.mp4"
              controls
              autoPlay
              loop
              muted
              className="h-full w-full rounded-3xl object-cover"
            >
              Your browser does not support the video tag.
            </video>
            {/* Decorative Overlay - Doesn't block interaction */}
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
          </div>

          {/* Form Section */}
          <div className="justify-between rounded-3xl border border-gray-700 bg-neutral-900 p-6 min-[900px]:w-[40%]">
            <div className="mb-6 flex items-center gap-4">
              <img src={ailogo} alt="Agent" className="h-12 w-12" />
              <>
                <p className="text-xl font-semibold text-gray-100">
                  Demo Agent
                </p>
                <p className="inline-block rounded-full bg-green-700 px-3 py-1 text-xs text-white">
                  Available
                </p>
              </>
            </div>
            <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Your name"
                name="name"
                className="rounded-full bg-neutral-800 p-6 text-gray-200 focus:outline-none"
              />
              <input
                type="email"
                placeholder="Your email"
                name="email"
                className="rounded-full bg-neutral-800 p-6 text-gray-200 focus:outline-none"
              />
              <input
                type="text"
                placeholder="Your phone number"
                name="phone"
                className="rounded-full bg-neutral-800 p-6 text-gray-200 focus:outline-none"
              />
              {status && (
                <p className="mt-2 text-center text-white">{status}</p>
              )}
              <button
                type="button"
                disabled={isSubmitting}
                className={`mt-4 rounded-full p-5 text-lg font-medium text-white shadow-md transition-transform hover:scale-105 ${
                  isSubmitting
                    ? "bg-neutral-600"
                    : "bg-neutral-800 hover:bg-neutral-600"
                }`}
              >
                {isSubmitting ? (
                  <div className="h-6 w-6 animate-spin rounded-full border-b-2 border-t-2 border-white"></div>
                ) : (
                  "Call Me Now"
                )}
              </button>
            </form>
          </div>
        </div>

        {/* Call to Action Section */}
        {/* <div className="mt-16 text-center">
          <h2 className="text-3xl font-bold text-gray-100">
            Step Into the Future of AI Communication - <br />
            <span className="text-blue-400">Transform Your Business Today</span>
          </h2>
        
          <a
            href="#get_started"
            className="mt-6 inline-block transform rounded-full bg-gradient-to-r from-blue-600 to-purple-600 px-10 py-4 text-lg font-semibold text-white shadow-lg transition-all hover:scale-110 hover:shadow-2xl focus:outline-none"
          >
            Get Started Now
          </a>
        </div> */}
      </section>
    </Section>
  );
};

export default AiHero;
